/// <reference path="define/jquery/jquery.d.ts" />
/// <reference path="define/jqueryui/jqueryui.d.ts" />

jQuery(function($) {
    
});